import axiosInstance from "@/api/axios-instance";
import {
  PaginatedUserRequests,
  UserRequestSort,
  UserRequestStatus,
  UserRequestType,
} from "../types/user-request";

export async function getUserRequests(params: {
  page?: number;
  limit?: number;
  type?: UserRequestType;
  status?: UserRequestStatus;
  date_from?: string;
  date_to?: string;
  q?: string;
  sort?: UserRequestSort;
  region?: string;
}): Promise<PaginatedUserRequests> {
  const response = await axiosInstance.get("/user-requests", { params });
  if (!response.status.toString().startsWith("2")) {
    throw new Error("Failed to load user requests");
  }
  return response.data;
}
